import { useEffect } from "react";
import { motion } from "framer-motion";
import { FaWhatsapp } from "react-icons/fa";
import Nav from "@/components/vtc/Nav";
import Hero from "@/components/vtc/Hero";
import Marquee from "@/components/vtc/Marquee";
import Services from "@/components/vtc/Services";
import Fleet from "@/components/vtc/Fleet";
import Testimonials from "@/components/vtc/Testimonials";
import Zone from "@/components/vtc/Zone";
import Footer from "@/components/vtc/Footer";
import ReservationDialog, { openReservation } from "@/components/vtc/ReservationDialog";

export default function Home() {
  useEffect(() => { document.title = "MN VTC — Chauffeur privé à Béziers | Confort, discrétion et élégance"; }, []);

  return (
    <main className="relative bg-ink text-blush">
      <Nav />
      <Hero />
      <Marquee />
      <Services />
      <Fleet />
      <Testimonials />
      <Zone />
      <Footer />
      <ReservationDialog />

      <motion.button
        data-testid="floating-whatsapp"
        onClick={openReservation}
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 2, type: "spring", stiffness: 200, damping: 15 }}
        className="fixed bottom-6 right-6 z-50 inline-flex h-14 w-14 items-center justify-center rounded-full bg-blush text-ink shadow-lg shadow-blush/20 transition-transform hover:scale-110"
        aria-label="Réserver sur WhatsApp"
      >
        <FaWhatsapp size={26} />
      </motion.button>
    </main>
  );
}
